export default function () {
    return {
        events: [],
        page: 1,
        totalEvents: 0,
        showCloneErrorMessage: false,
    }
}
